import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgCollapse = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={24}
    height={24}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d='M12.01 9.82L5.30002 3.11C5.10002 2.91 5.10002 2.6 5.30002 2.4C5.50002 2.2 5.81002 2.2 6.01002 2.4L12 8.4L17.98 2.42C18.18 2.22 18.49 2.22 18.69 2.42C18.89 2.62 18.89 2.93 18.69 3.13L12 9.82H12.01Z' />
    <path d='M18.34 21.74C18.21 21.74 18.08 21.69 17.99 21.59L11.99 15.59L6.01002 21.57C5.81002 21.77 5.50002 21.77 5.30002 21.57C5.10002 21.37 5.10002 21.06 5.30002 20.86L11.99 14.17L18.69 20.87C18.89 21.07 18.89 21.38 18.69 21.58C18.59 21.68 18.46 21.73 18.34 21.73V21.74Z' />
  </svg>
);
export default SvgCollapse;
